import {
  imgBancoDoBrasil,
  imgBancoInter,
  imgBancoSafra,
  imgBradesco,
  imgBtgPactual,
  imgC6Bank,
  imgCaixa,
  imgCelcoin,
  imgCnh,
  imgDefaultBank,
  imgItau,
  imgNubank,
  imgPicPay,
  imgSantander,
  imgSicoob,
  imgSicredi,
  imgXP,
} from '~/assets/images/bank';
import type { Institution } from '~/store/contracts/interfaces';

interface BankEntry {
  logo: string;
  keywords: string[];
}

const BANKS: BankEntry[] = [
  { logo: imgBancoDoBrasil, keywords: ['banco do brasil', 'bb '] },
  { logo: imgCaixa, keywords: ['caixa', 'cef'] },
  { logo: imgBradesco, keywords: ['bradesco'] },
  { logo: imgItau, keywords: ['itau', 'itaú'] },
  { logo: imgSantander, keywords: ['santander'] },
  { logo: imgSicredi, keywords: ['sicredi'] },
  { logo: imgSicoob, keywords: ['sicoob'] },
  { logo: imgBancoSafra, keywords: ['safra'] },
  { logo: imgBtgPactual, keywords: ['btg'] },
  { logo: imgBancoInter, keywords: ['inter'] },
  { logo: imgC6Bank, keywords: ['c6'] },
  { logo: imgNubank, keywords: ['nubank', 'nu pagamentos'] },
  { logo: imgXP, keywords: ['xp '] },
  { logo: imgPicPay, keywords: ['picpay'] },
  { logo: imgCelcoin, keywords: ['celcoin'] },
  { logo: imgCnh, keywords: ['cnh'] },
];

const normalize = (input: string): string =>
  input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export interface InstitutionLike {
  name?: string;
  shortCode?: string;
}

export const getBankLogo = (
  institution?: InstitutionLike | Institution,
): string => {
  if (!institution) return imgDefaultBank;
  const haystack = `${normalize(institution.name ?? '')} ${normalize(
    institution.shortCode ?? '',
  )}`;
  if (!haystack.trim()) return imgDefaultBank;
  for (const entry of BANKS) {
    if (entry.keywords.some((kw) => haystack.includes(kw))) return entry.logo;
  }
  return imgDefaultBank;
};

export const hasBankLogo = (institution?: InstitutionLike | Institution): boolean =>
  getBankLogo(institution) !== imgDefaultBank;
